import { TranslationService } from '../services/TranslationService';

export function autoTranslate(text: string): string {
  const returnedText = text.replace(/\{\{translated\('(.*)'\)\}\}/g, (match: string, p1: string) => TranslationService.translate(p1));
  return returnedText;
}